import IMultiSelectItem from '@/interfaces/selects/IMultiSelectItem';
import ISelectItemCustom from '@/interfaces/selects/ISelectItemCustom'
/**
 * Format for default select
 */
export function transformMultiSelectArray(base: string[]): IMultiSelectItem[] {
    return base.map((name, index) => ({
        value: index,
        label: name
    }));
}

export function transformMultiSelect(base: any, fieldName:string = 'name', fieldValue:string='id'): IMultiSelectItem[] {
    return base.map((item:any) => ({
        value: item[fieldValue],
        label: item[fieldName]
    }));
}